/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Req_R2Inputs */

const en_fc_online_req_r2 = /** @type {(inputs: Fc_Online_Req_R2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use HTTPS or localhost. WebGPU and the clipboard only work in a secure context.`)
};

/**
* | output |
* | --- |
* | "Use HTTPS or localhost. WebGPU and the clipboard only work in a secure context." |
*
* @param {Fc_Online_Req_R2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_req_r2 = /** @type {((inputs?: Fc_Online_Req_R2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Req_R2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_req_r2(inputs)
});
export { fc_online_req_r2 as "fc.online.req.r2" }